/**
 * @file 请求标识
 * @author wangzhuang
 */

// 文章列表
export const GET_FQZ_ARTICLES = 'GET_FQZ_ARTICLES';

// 文章详情
export const GET_ARTICLE_AID = 'GET_ARTICLE_AID';